<input
  class="rb__input"
  role="radio"
  type="radio"
  [id]="id"
  [attr.name]="name"
  [value]="value"
  [checked]="checked"
  [disabled]="disabled"
  (change)="onChange($event)"
/>

<span class="rb__control" aria-hidden="true"></span>

<span class="rb__label"><ng-content></ng-content></span>
